import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect, { components } from 'react-select';
import styled from 'styled-components';
import Icon, { ICON_TYPE } from '../base/icon';

//
// More Info
// https://react-select.com/components
//

// Our Custom Component
const OptionStyles = styled.div`
  background-color: ${props => props.theme.colors.secondary};
  border-radius: 0;
  padding: 8px 16px;

  &:nth-child(odd) {
    background: ${props => props.theme.colors.bodyBackground};

    &:hover {
      background: ${props => props.theme.colors.buttonSelected};
    }
  }

  &:nth-child(even) {
    background: ${props => props.theme.colors.selectBackground};

    &:hover {
      background: ${props => props.theme.colors.buttonSelected};
    }
  }
`;

const DropdownStyles = styled.div`
  border: 0;
  outline: none !important;
  background-color: ${props => props.theme.colors.secondary};
`;

const ValueContainerStyle = styled.div`
  border-radius: 0;
  padding: 8px;
`;

const SelectValueLabel4 = styled.h4`
  display: inline-block;
  vertical-align: middle;
  line-height: 1.2;
  cursor: default;
`;

const SelectValueLabel3 = styled.h3`
  vertical-align: middle;
  line-height: 1.2;
  cursor: default;
`;

const SelectValuePrice = styled.p`
  cursor: default;
  color: ${props => props.theme.colors.selectText};
`;

const StyledReactSelect = styled(ReactSelect)`
  border-radius: 0;
  background: ${props => props.theme.colors.bodyBackground};
`;

const ControlStyle = styled(components.Control)`
  border-radius: 0 !important;
  box-shadow: none !important;
  border-color: ${props => props.theme.colors.inputBorder} !important;
  padding-bottom: 0;

  &:hover {
    box-shadow: none;
  }
`;

const InputStyle = styled(components.Input)`
  color: transparent;
  width: 0;
`;

const MenuStyle = styled(components.Menu)`
  border-radius: 0;
  background: ${props => props.theme.colors.bodyBackground};
  outline: none;
`;

const Option = ({ innerRef, innerProps, data, className }) => {
  const { title, subtitle, description } = data;

  return (
    <OptionStyles ref={innerRef} {...innerProps} className={className}>
      <SelectValueLabel4>{title}</SelectValueLabel4>
      {subtitle && <SelectValueLabel3>{subtitle}</SelectValueLabel3>}
      <SelectValuePrice>{description}</SelectValuePrice>
    </OptionStyles>
  );
};

const ValueContainer = ({ children, ...props }) => {
  const { getValue, hasValue } = props;
  const values = getValue();
  if (!hasValue) {
    return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
  }

  const { title, subtitle, description } = values[0];

  return (
    <components.ValueContainer {...props}>
      {children}
      <ValueContainerStyle className={props.className}>
        <SelectValueLabel4>{title}</SelectValueLabel4>
        {subtitle && <SelectValueLabel3>{subtitle}</SelectValueLabel3>}
        <SelectValuePrice>{description}</SelectValuePrice>
      </ValueContainerStyle>
    </components.ValueContainer>
  );
};

const DropdownIndicator = () => {
  return (
    <DropdownStyles>
      <Icon mr={1} width={23} height={23} type={ICON_TYPE.DROPDOWN} />
    </DropdownStyles>
  );
};

const IndicatorSeparator = () => <span />;
const Input = props => <InputStyle {...props} />;
const Control = props => <ControlStyle {...props} />;
const Menu = props => <MenuStyle {...props}>{props.children}</MenuStyle>;

const DropDown = props => {
  const { items, active, onChange } = props;

  const handleOnChange = selectedOption => {
    onChange(selectedOption.value);
  };

  const value = items.find(item => item.value === active);

  return (
    <StyledReactSelect
      value={value}
      options={items}
      onChange={handleOnChange}
      components={{
        Option,
        ValueContainer,
        DropdownIndicator,
        IndicatorSeparator,
        Control,
        Menu,
        Input,
      }}
      searchable={false}
    />
  );
};

DropDown.propTypes = {
  items: PropTypes.array,
  active: PropTypes.string,
  onChange: PropTypes.func,
};

export default DropDown;
